import React, { useEffect } from 'react';
import Input from '../../Input';
import style from '../../../assets/styles/AddExpensesForm.module.scss';
import { UpdateMenuMessage } from '../../Messages/UpdateMenuMessage.js';
import CloseBtn from '../../closeBtn';
// import ProductVolumeAdjustmentNote from './ProductVolumeAdjustmentNote';
import { getDocs, getFirestore, collection, doc } from 'firebase/firestore';
import { addDoc, updateDoc } from '../../../api/FirestoreInterceptor';
import { db } from '../../../config-firebase/firebase.js';
import { getBtnData, addItemToCollection, logStockUsage, registerDailyStockMovement } from '../../../api/Api';
//import { alertMinimunAmount } from '../../../Helpers/Helpers';
import { GlobalContext } from '../../../GlobalContext';
import { checkUnavaiableRawMaterial } from '../../../Helpers/Helpers.js';
import { tooltips } from '../../../constants/tooltips.js';

const AddExpensesForm = ({ setShowPopup, setRefreshData, obj, forcedEntryType, outgoingExpensesList, onOpenRegisterExpense, onOpenRegisterProvider, onOpenRegisterProduct, refreshDataTrigger }) => {
  const global = React.useContext(GlobalContext);
  const [loadingAvailableMenuDishes, setLoadingAvailableMenuDishes] =
    React.useState(false);
  const [form, setForm] = React.useState({
    name: '',
    value: 0,
    dueDate: '',
    paymentDate: '',
    expenseId: '',
    category: '',
    account: '',
    provider: '',
    confirmation: 0,
    items: [],
    numberOfTimes: 1,
    paymentProof: '',
    entryType: forcedEntryType || 'expense',
    category: forcedEntryType === 'stock' ? 'variable' : '',
    name: forcedEntryType === 'stock' ? 'Entrada de Estoque' : '',
    groupId: '',
  });

  const [item, setItem] = React.useState({
    product: '',
    amount: 0,
    CostPerUnit: 0,
    minimumAmount: 0,
    totalCost: 0,
    volumePerUnit: 0,
    adjustmentExpenseNote: '',
    currentAmountProduct: 0,
    idProduct: '',
    totalVolume: 0,
    operationSupplies: false,
    unitOfMeasurement: '',
  });
  const [showItemsDetailsForm, setShowItemsDetailsForm] = React.useState(forcedEntryType === 'stock');
  const [itemArrayList, setItemArrayList] = React.useState([]);
  const [productList, setProductList] = React.useState(null);
  const [providerList, setProviderList] = React.useState(null);
  const [expensesList, setExpensesList] = React.useState(null);
  const [note, setNote] = React.useState('');
  const [showPopupNote, setShowPopupNote] = React.useState(null);
  //const [currentAmountProduct, setCurrentAmountProduct] = React.useState('');
  const [total, setTotal] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    const fetchRegisterLists = async () => {
      const [dataProduct, dataProvider, dataExpenses] = await Promise.all([
        getBtnData('product'),
        getBtnData('provider'),
        getBtnData('expenses'),
      ]);

      if (dataProduct && dataProduct.length > 0) {
        let filteredProducts = dataProduct;
        if (forcedEntryType === 'stock') {
          // Only Raw Material (Direta) - include items where operationSupplies is false, undefined or null
          filteredProducts = dataProduct.filter(p => p.operationSupplies === false || p.operationSupplies === undefined || p.operationSupplies === null);
        } else {
          // Only Supplies (Indireta)
          filteredProducts = dataProduct.filter(p => p.operationSupplies === true);
        }
        setProductList(sortedData(filteredProducts));
      }
      if (dataExpenses && dataExpenses.length > 0) {
        setExpensesList(sortedData(dataExpenses));
      }
      if (dataProvider && dataProvider.length > 0) {
        setProviderList(sortedData(dataProvider));
      }
    };
    fetchRegisterLists();

    const handleFocus = () => fetchRegisterLists();
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [forcedEntryType, refreshDataTrigger]);

  const sortedData = (list) => {
    return list.sort((a, b) => a.name.localeCompare(b.name));
  };

  React.useEffect(() => {
    if (itemArrayList) {
      let totalItemsCost = 0;
      itemArrayList.forEach((item) => {
        totalItemsCost += item.totalCost;
      });
      setTotal(totalItemsCost);
    }
    renderTableItem();
  }, [itemArrayList]);

  React.useEffect(() => {
    console.log('total     ', total);
    setForm({
      ...form,
      items: itemArrayList,
      value: total,
      confirmation: total,
    });
  }, [total]);

  React.useEffect(() => {
    if (obj) {
      setForm({
        name: obj.name || '',
        value: obj.value || 0,
        dueDate: obj.dueDate || '',
        paymentDate: obj.paymentDate || '',
        category: obj.category || '',
        confirmation: obj.confirmation || 0,
        expenseId: String(obj.expenseId || ''),
        account: obj.account || '',
        provider: obj.provider || '',
        items: obj.items || [],
        numberOfTimes: obj.numberOfTimes || 1,
        paymentProof: obj.paymentProof || '',
        entryType: obj.entryType || 'expense',
        groupId: obj.groupId || '',
      });

      if (obj.items && obj.items.length > 0) {
        setItemArrayList(obj.items);
        setShowItemsDetailsForm(true);
      }
    } else {
      setForm({
        name: '',
        value: 0,
        dueDate: '',
        paymentDate: '',
        category: '',
        confirmation: 0,
        expenseId: '',
        account: '',
        provider: '',
        items: [],
        paymentProof: '',
        groupId: '',
      });
    }
  }, [obj]);

  React.useEffect(() => {
    if (item.CostPerUnit !== 0 && item.amount !== 0) {
      setItem((prevItem) => ({
        ...prevItem,
        totalCost: prevItem.CostPerUnit * prevItem.amount,
      }));
    }
  }, [item.CostPerUnit, item.amount]);

  React.useEffect(() => {
    if (item.volumePerUnit !== 0 && item.amount !== 0) {
      setItem((prevItem) => ({
        ...prevItem,
        totalVolume: prevItem.volumePerUnit * prevItem.amount,
      }));
    }
  }, [item.volumePerUnit, item.amount]);

  React.useEffect(() => {
    if (showPopupNote !== true) {
      setItem({
        ...item,
        adjustmentExpenseNote: note,
      });
    }
  }, [showPopupNote]);

  const addItem = () => {
    if (item.product === '') {
      alert('Produto não foi selecionado. Por favor, selecione o produto.');
      return;
    }

    if (Number(item.amount) <= 0 || Number(item.CostPerUnit) <= 0) {
      alert('A quantidade e o custo por unidade devem ser maiores que zero para evitar falhas no cálculo de custos do sistema.');
      return;
    }

    if (Number(item.volumePerUnit) <= 0 && item.operationSupplies === false) {
      alert('O volume por embalagem deve ser maior que zero para compor o estoque da matéria prima.');
      return;
    }

    setItem({
      ...item,
      totalVolume: item.volumePerUnit * item.amount,
    });

    setItemArrayList((prevArrayList) => [...prevArrayList, item]);
    
    console.log('total ', total);
    setItem({
      product: '',
      amount: 0,
      CostPerUnit: 0,
      adjustmentExpenseNote: '',
      currentAmountProduct: '',
      totalCost: 0,
      volumePerUnit: 0,
      idProduct: '',
      totalVolume: 0,
      unitOfMeasurement: '',
    });
  };
  const deleteItem = (indexToRemove) => {
    setItemArrayList((prevArrayList) =>
      prevArrayList.filter((_, index) => index !== indexToRemove)
    );
  };

  const formatPaymentDateWithCurrentTime = (dateStr) => {
    if (!dateStr) return '';
    let day, month, year;
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      year = parts[0];
      month = parts[1];
      day = parts[2];
    } else if (dateStr.includes('/')) {
      const parts = dateStr.split('/');
      day = parts[0];
      month = parts[1];
      year = parts[2];
    } else {
      return dateStr;
    }
    const today = new Date();
    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const seconds = String(today.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  const renderTableItem = () => {
    return (
      <div className={style.ContainerTableIngredients}>
        <table>
          <thead>
            <tr>
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Custo por unidade</th>
              <th>Custo Total</th>
              <th>Volume</th>
              <th>Unidade de medida</th>
              <th>Excluir</th>
            </tr>
          </thead>
          <tbody>
            {itemArrayList &&
              itemArrayList.length > 0 &&
              itemArrayList.map((requestItem, index) => (
                <tr key={index}>
                  <td>{requestItem.product}</td>
                  <td>{requestItem.amount}</td>
                  <td>{requestItem.CostPerUnit}</td>
                  <td>{requestItem.totalCost}</td>
                  <td>{requestItem.volumePerUnit}</td>
                  <td>{requestItem.unitOfMeasurement}</td>
                  <td>
                    {' '}
                    {requestItem.adjustmentExpenseNote ? 'nota' : 'sem nota'}
                  </td>
                  <td onClick={() => deleteItem(index)}>X</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleStock = async (originalItemsStock, account = '000', paymentDate) => {
    // Clone array to prevent mutating the items going to the expenses list
    const itemsStock = JSON.parse(JSON.stringify(originalItemsStock));
    console.log('objeto recebido   ', itemsStock);

    const data = await getBtnData('stock'); // Obtém todos os registros existentes no estoque

    for (let i = 0; i < itemsStock.length; i++) {
      const currentItem = itemsStock[i];

      // Verifica se o item já existe no banco de dados
      const itemFinded = data?.find(
        (itemSearch) => itemSearch.product === currentItem.product
      );
      if (itemFinded) {
        // Atualiza os valores de custo e volume totais
        let previousCost = itemFinded.totalCost;
        const adjustmentExpenseNote = currentItem.adjustmentExpenseNote;
        let previousVolume = itemFinded.totalVolume;

        if (currentItem.currentAmountProduct) {
          previousVolume = Number(currentItem.currentAmountProduct);

          // Evita divisão por zero
          if (currentItem.totalVolume && currentItem.totalCost) {
            const unitCost = currentItem.totalCost / currentItem.totalVolume;
            previousCost = unitCost * currentItem.currentAmountProduct;
          } else {
            console.warn(
              'Não foi possível calcular o custo unitário: totalVolume ou totalCost ausentes ou inválidos.'
            );
          }
        }
        const cost = currentItem.totalCost;
        const pack = Number(itemFinded.amount) + Number(currentItem.amount);
        const volume = currentItem.totalVolume;
        const unit = currentItem.unitOfMeasurement;
        
        currentItem.amount = Math.max(0, pack); // Ensure the stock total amount is updated
        currentItem.totalCost += Number(
          currentItem.currentAmountProduct
            ? previousCost
            : itemFinded.totalCost || 0
        );
        currentItem.totalVolume += Number(
          currentItem.currentAmountProduct
            ? previousVolume
            : itemFinded.totalVolume || 0
        );

        if (currentItem.totalVolume <= 0) {
          currentItem.totalVolume = 0;
          currentItem.totalCost = 0;
        } else if (currentItem.totalCost < 0) {
          currentItem.totalCost = 0;
        }

        // Recalculate and update the CostPerUnit using the new Weighted Average
        if (currentItem.totalVolume > 0) {
          currentItem.CostPerUnit = Number((currentItem.totalCost / currentItem.totalVolume).toFixed(2));
        } else {
          currentItem.CostPerUnit = 0;
        }

        // Remove UsageHistory local se existir
        delete currentItem.UsageHistory;
        currentItem.operationSupplies =
          'operationSupplies' in itemsStock[i]
            ? itemsStock[i].operationSupplies
            : false;
        const logEvent = stockHistoryList(
          itemFinded,
          account,
          adjustmentExpenseNote,
          paymentDate,
          pack,
          cost,
          unit,
          volume,
          previousVolume,
          previousCost,
          currentItem.totalCost,
          currentItem.totalVolume
        );
        console.log('Item atual  ', currentItem);

        // Atualiza o registro no banco de dados
        const docRef = doc(db, 'stock', itemFinded.id);
        await updateDoc(docRef, currentItem);
        await logStockUsage(itemFinded.id, logEvent);
        setLoadingAvailableMenuDishes(true);
        const res = await checkUnavaiableRawMaterial(itemFinded.id);
        setLoadingAvailableMenuDishes(res);
      } else {
        const previousCost = 0;
        const constpreviousVolume = 0;
        const adjustmentExpenseNote = '';
        const cost = currentItem.totalCost;
        const pack = Number(currentItem.amount);
        const volume = currentItem.totalVolume;
        const unit = currentItem.unitOfMeasurement;

        // Cria um novo registro para o item no banco de dados
        const logEvent = stockHistoryList(
          currentItem,
          account,
          adjustmentExpenseNote,
          paymentDate,
          pack,
          cost,
          unit,
          volume,
          constpreviousVolume,
          previousCost,
          currentItem.totalCost,
          currentItem.totalVolume
        );
        delete currentItem.UsageHistory;
        
        const newDocRef = await addDoc(collection(db, 'stock'), currentItem);
        await logStockUsage(newDocRef.id, logEvent);
        setLoadingAvailableMenuDishes(true);
        const res = await checkUnavaiableRawMaterial(newDocRef.id);
        setLoadingAvailableMenuDishes(res);
      }
    }
  };
  const stockHistoryList = (
    item,
    account,
    adjustmentExpenseNote,
    paymentDate,
    pack,
    cost,
    unit,
    volume,
    previousVolume,
    previousCost,
    totalCost,
    totalVolume,
    orderNumber = ''
  ) => {
    const stockEventRegistration = {
      date: paymentDate,
      outputProduct: 0,
      category: account || 0,
      unit: unit,
      package: pack,
      inputProduct: volume,
      cost: cost,
      adjustmentExpenseNote: adjustmentExpenseNote,
      previousVolume: previousVolume,
      previousCost: previousCost,
      ContentsInStock: totalVolume ? totalVolume : 0,
      totalResourceInvested: totalCost,
      orderNumber: orderNumber,
    };
    return stockEventRegistration;
  };
  const distributeItemsToExpenseList = async (
    items,
    account,
    provider,
    paymentDate,
    expenseId
  ) => {
    if (obj || Object.keys(obj).length > 0) {
      console.warn('O objeto "obj" está vazio ou não possui valores.');
      return;
    }
    try {
      const itemsWithAdditionalData = items.map((item) => ({
        ...item,
        account,
        provider,
        paymentDate,
        expenseID: expenseId,
      }));
      console.log('Formato dos itens  ', itemsWithAdditionalData);
      const writePromises = itemsWithAdditionalData.map(async (item) => {
        await addItemToCollection('expenseItems', item);
      });

      await Promise.all(writePromises);
      console.log("Todos os itens foram adicionados à coleção 'stockItems'.");
    } catch (error) {
      console.error('Erro ao distribuir itens para o estoque:', error);
    }
  };

  const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
  };

  const parseToDate = (dateVal) => {
    if (!dateVal) return null;
    if (dateVal instanceof Date) return dateVal;
    if (typeof dateVal.toDate === 'function') return dateVal.toDate();
    if (typeof dateVal.seconds === 'number') return new Date(dateVal.seconds * 1000);
    if (typeof dateVal === 'number') return isNaN(new Date(dateVal).getTime()) ? null : new Date(dateVal);
    if (typeof dateVal === 'string') {
      const str = dateVal.trim();
      if (!str) return null;
      if (str.includes('/')) {
        const parts = str.split(' - ')[0].split(' ')[0].trim().split('/');
        if (parts.length === 3) return new Date(parts[2], parts[1] - 1, parts[0]);
      }
      if (str.includes('-')) {
        const parts = str.split('T')[0].split(' ')[0].trim().split('-');
        if (parts.length === 3) return new Date(parts[0], parts[1] - 1, parts[2]);
      }
    }
    const d = new Date(dateVal);
    return isNaN(d.getTime()) ? null : d;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const installments = Number(form.numberOfTimes) || 1;
    const isFixed = form.category === 'fixed';

    const saveExpense = async (data) => {
      if (obj) {
        if (obj.applyToFuture && outgoingExpensesList) {
          const targetDate = parseToDate(obj.dueDate || obj.paymentDate || obj.date) || new Date(0);
          
          const futureExpenses = outgoingExpensesList.filter((expense) => {
            if (obj.groupId) {
              return expense.groupId === obj.groupId && (parseToDate(expense.dueDate || expense.paymentDate || expense.date) || new Date(0)) >= targetDate;
            }
            return (
              expense.expenseId === obj.expenseId &&
              expense.provider === obj.provider &&
              (expense.numberOfTimes > 1) &&
              (parseToDate(expense.dueDate || expense.paymentDate || expense.date) || new Date(0)) >= targetDate
            );
          });

          for (const expense of futureExpenses) {
            const docRef = doc(db, 'outgoing', expense.id);
            // We only update the common fields that were changed, keeping the specific dates of the future occurrences
            const updatedData = {
              ...expense,
              value: data.value,
              account: data.account,
              provider: data.provider,
              items: data.items,
              category: data.category,
              paymentProof: data.paymentProof,
            };
            await updateDoc(docRef, updatedData);
          }
        } else {
          const docRef = doc(db, 'outgoing', obj.id);
          await updateDoc(docRef, data);
        }
      } else {
        await addDoc(collection(db, 'outgoing'), data);
      }
    };

    try {
      if (!obj && isFixed && installments > 1) {
        // Create multiple installments
        const baseDueDate = new Date(form.dueDate + 'T00:00:00');
        const groupId = `group_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        for (let i = 0; i < installments; i++) {
          const installmentDate = new Date(baseDueDate);
          installmentDate.setMonth(baseDueDate.getMonth() + i);
          
          const installmentData = {
            ...form,
            name: `${form.name} (${i + 1}/${installments})`,
            dueDate: installmentDate.toISOString().split('T')[0],
            // Only the first installment might have payment data if filled, 
            // others start empty unless the user intended otherwise.
            // But usually, one creates the debt first.
            paymentDate: i === 0 ? form.paymentDate : '',
            confirmation: i === 0 ? Number(form.confirmation) : 0,
            numberOfTimes: installments,
            paymentProof: i === 0 ? form.paymentProof : '',
            groupId: groupId,
          };

          const enrichedItems = installmentData.items.map((item) => ({
            ...item,
            account: installmentData.account,
            provider: installmentData.provider,
            paymentDate: installmentData.paymentDate,
            expenseId: installmentData.expenseId,
          }));
          
          await addDoc(collection(db, 'outgoing'), { ...installmentData, items: enrichedItems });
        }
      } else {
        // Single save
        const formattedDate = formatPaymentDateWithCurrentTime(form.paymentDate);
        const enrichedItems = form.items.map((item) => ({
          ...item,
          account: form.account,
          provider: form.provider,
          paymentDate: formattedDate,
          expenseId: form.expenseId,
        }));

        if (enrichedItems.length > 0) {
          await handleStock(enrichedItems, form.account, formattedDate);
          const data = await getBtnData('stock');
          handleWarningCleanup(data, enrichedItems);
          await registerDailyStockMovement('Entrada Financeira/Despesa');
        }

        await saveExpense({ 
          ...form, 
          items: enrichedItems,
          // Ensure dueDate is set for stock entries if missing
          dueDate: forcedEntryType === 'stock' ? form.paymentDate : form.dueDate
        });
      }

      setRefreshData((prev) => !prev);
      setShowPopup(false);
      setIsSubmitting(false);
      setForm({
        name: '',
        value: 0,
        dueDate: '',
        paymentDate: '',
        category: '',
        confirmation: 0,
        expenseId: '',
        account: '',
        provider: '',
        items: [],
        numberOfTimes: 1,
        paymentProof: '',
      });
    } catch (error) {
      console.error('Erro ao salvar documento:', error);
      setIsSubmitting(false);
    }
  };

  const handleWarningCleanup = (data, enrichedItems) => {
    const stored =
      JSON.parse(localStorage.getItem('warningAmountMessage')) || [];

    data.forEach((item) => {
      const match = enrichedItems.find((i) => i.idProduct === item.idProduct);
      if (match && item.totalVolume > item.minimumAmount) {
        // encontra o índice da mensagem correspondente ao produto
        const msgIndex = stored.findIndex(
          (msg) =>
            typeof msg === 'string' && msg.includes(`produto ${item.product}`)
        );

        if (msgIndex !== -1) {
          stored[msgIndex] = ''; // limpa apenas o aviso desse produto
        }
      }
    });

    localStorage.setItem('warningAmountMessage', JSON.stringify(stored));
    global.setWarningLowRawMaterial(stored);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    toggleFormItemsByExpenseType(id, value);

    if (id === 'name') {
      const selectedExpense = expensesList.find(
        (item) => item.humanId === Number(value)
      );

      if (selectedExpense) {
        setForm((prevForm) => ({
          ...prevForm,
          name: selectedExpense.name,
          expenseId: selectedExpense.humanId,
          numberOfTimes: selectedExpense.numberOfTimes || 1,
        }));
        return;
      }
    }

    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const setEntryType = (type) => {
    if (forcedEntryType) return; // Don't override if forced
    setForm(prev => ({ ...prev, entryType: type }));
  };

  const toggleFormItemsByExpenseType = (id, value) => {
    if (id === 'name') {
      const selectedExpense = expensesList.find(
        (item) => item.humanId === Number(value)
      );
      if (selectedExpense && selectedExpense.multiply === 'composto') {
        setShowItemsDetailsForm(true);
        setEntryType('expense');
      } else {
        setShowItemsDetailsForm(false);
        setEntryType('expense');
      }
    }
  };

  const handleItemChange = (e) => {
    const { id, value } = e.target;

    if (id === 'product') {
      const selectedProduct = productList[value];
      console.log('Produto selecionado:', selectedProduct);

      if (selectedProduct) {
        setItem((prevForm) => ({
          ...prevForm,
          idProduct: selectedProduct.idProduct
            ? selectedProduct.idProduct
            : selectedProduct.id,
          product: selectedProduct.name,
          operationSupplies: selectedProduct.operationSupplies ? true : false,
          unitOfMeasurement: selectedProduct.unitOfMeasurement || '',
          minimumAmount: selectedProduct.minimumAmount || 0,
        }));
      } else {
        setItem((prevForm) => ({
          ...prevForm,
          idProduct: '',
          product: '',
          unitOfMeasurement: '',
        }));
      }
      return;
    } else {
      if (id === 'amount' && item.unitOfMeasurement === 'un') {
        console.log(item.unitOfMeasurement);
        setItem((prevForm) => ({
          ...prevForm,
          [id]: value,
          volumePerUnit: 1,
        }));
        return;
      }
      // Comportamento genérico para outros inputs
      setItem((prevForm) => ({
        ...prevForm,
        [id]: value,
      }));
    }
  };
  const handleFocus = () => {
    console.log('To aqui');
  };
  const checkCurrentValue = () => {
    if (item.currentAmountProduct !== '') {
      setShowPopupNote(true);
    }
  };

  return (
    <div className={style.containerAddExpensesForm}>
      <CloseBtn setClose={setShowPopup} />
      <div className={style.updateMenuMessageWrapper}>
        {loadingAvailableMenuDishes && <UpdateMenuMessage />}
      </div>

      <h1>Adicione uma nova despesa</h1>

      <form onSubmit={handleSubmit} className="m-1">
        <div className={style.formProduct}>
          {/* Row 1: Name, Category, Provider */}
          {forcedEntryType !== 'stock' && (
            <>
              <div className={style.selectform}>
                <label style={{ display: 'block', whiteSpace: 'nowrap', marginBottom: '4px', fontSize: '16px' }}>Despesa</label>
                <select id="name" required value={form.expenseId} onChange={handleChange} onFocus={handleFocus}>
                  <option value="" disabled hidden>Selecione uma despesa</option>
                  {expensesList && expensesList.map((expense, index) => (
                    <option key={index} value={String(expense.humanId)}>{expense.name}</option>
                  ))}
                </select>
              </div>
              <div className={style.selectform}>
                <label style={{ display: 'block', whiteSpace: 'nowrap', marginBottom: '4px', fontSize: '16px' }}>Tipo de custo</label>
                <select id="category" value={form.category} required onChange={handleChange}>
                  <option value="" disabled hidden>Selecione</option>
                  <option value="fixed">Fixo</option>
                  <option value="variable">Variável</option>
                </select>
              </div>
            </>
          )}
          <div className={style.selectform} title={tooltips.addStockEntryForm.provider}>
            <label style={{ display: 'block', whiteSpace: 'nowrap', marginBottom: '4px', fontSize: '16px' }}>Fornecedor</label>
            <select id="provider" required onChange={handleChange} value={form.provider} title={tooltips.addStockEntryForm.provider}>
              <option value="" disabled hidden>Selecione</option>
              {providerList && providerList.map((category, index) => (
                <option key={index} value={category.provider}>{category.name}</option>
              ))}
            </select>
          </div>

          {/* Row 2: Value, DueDate, NumberOfTimes */}
          {showItemsDetailsForm ? (
            <div 
              className={style.customTooltipWrapper} 
              data-tooltip="Nesta modalidade de despesa composta (com itens), este campo será preenchido automaticamente com a soma do custo dos itens adicionados abaixo."
            >
              <Input 
                id="value" 
                required 
                label="Valor" 
                value={form.value} 
                type="number" 
                onChange={handleChange} 
                readOnly
                style={{ opacity: 0.4, cursor: 'not-allowed', backgroundColor: '#f0f0f0' }}
                title=""
              />
            </div>
          ) : (
            <Input 
              id="value" 
              required 
              label="Valor" 
              value={form.value} 
              type="number" 
              onChange={handleChange} 
              readOnly={forcedEntryType === 'stock'}
              style={forcedEntryType === 'stock' ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}}
              title={tooltips.addStockEntryForm.value}
            />
          )}
          {forcedEntryType !== 'stock' && (
            <Input id="dueDate" required label="Vencimento" value={form.dueDate} type="date" onChange={handleChange} />
          )}
          {forcedEntryType !== 'stock' && (
            <Input id="numberOfTimes" label="Parcelas" value={form.numberOfTimes} type="number" onChange={handleChange} />
          )}

          {/* Row 3: Account, etc */}
          <div className={style.inputWithBtnRow}>
            <div className={style.flexGrow}>
              <Input id="account" required label="Nota fiscal" value={form.account} type="text" onChange={handleChange} title={tooltips.addStockEntryForm.account} />
            </div>
            {forcedEntryType !== 'stock' && (
              <button 
                type="button" 
                className={style.registerNotRegisteredBtn}
                onClick={onOpenRegisterExpense}
                title="Cadastrar despesa não encontrada em outra aba"
              >
                cadastrar despesa<br />não encontrada
              </button>
            )}
          </div>

          {/* Row 4: PaymentProof */}
          <div className={style.paymentProofRow}>
            <div className={style.flexGrow}>
              <Input
                id="paymentProof"
                autoComplete="off"
                label="Link do Comprovante (PDF)"
                value={form.paymentProof}
                type="text"
                onChange={handleChange}
                title={tooltips.addStockEntryForm.paymentProof}
              />
            </div>
            <div className={style.paymentProofBtns}>
              {form.paymentProof && (
                <button 
                  type="button" 
                  className={style.accessBtn}
                  onClick={() => window.open(form.paymentProof, '_blank')}
                >
                  Acessar Comprovante
                </button>
              )}
              {forcedEntryType !== 'stock' && (
                <button 
                  type="button" 
                  className={style.registerNotRegisteredBtn}
                  onClick={onOpenRegisterProvider}
                  title="Cadastrar fornecedor não encontrado em outra aba"
                >
                  cadastrar fornecedor<br />não encontrado
                </button>
              )}
            </div>
          </div>
        </div>
        {showItemsDetailsForm && (
          <fieldset>
            <legend>Adicionar Item</legend>
            <div className={style.selectform} title={tooltips.addStockEntryForm.product}>
              <select
                id="product"
                value={productList?.findIndex(
                  (product) => product.name === item.product
                )}
                onChange={handleItemChange}
                title={tooltips.addStockEntryForm.product}
              >
                <option value="">Selecione um produto</option>
                {productList &&
                  productList.map((category, index) => (
                    <option key={index} value={index}>
                      {category.name}
                    </option>
                  ))}
              </select>
            </div>

            <Input
              title={tooltips.addStockEntryForm.amount}
              id="amount"
              autoComplete="off"
              className="num"
              label="Qtd de volumes"
              value={item.amount}
              type="number"
              onChange={handleItemChange}
            />
            <Input
              title={tooltips.addStockEntryForm.CostPerUnit}
              id="CostPerUnit"
              autoComplete="off"
              className="num"
              label="Custo por vol"
              value={item.CostPerUnit}
              type="number"
              onChange={handleItemChange}
            />
            <Input
              title={tooltips.addStockEntryForm.totalCost}
              id="totalCost"
              autoComplete="off"
              className="num"
              label="Custo Total"
              value={item.totalCost}
              type="number"
              onChange={handleItemChange}
            />
            {/* <Input
              title="Caso o valor em estoque desse produto não seja verdadeiro atualize o valor correto
              e na tela de 'digite sua Jusitificativa' escreva uma nota dizendo porque o valor restante
              desse produto em estoque não correponde a realidade. Ex: data de validade vencida"
              id="currentAmountProduct"
              autoComplete="off"
              className="num"
              label="Volume atual do produto"
              value={item.currentAmountProduct}
              type="text"
              onChange={handleItemChange}
              onBlur={checkCurrentValue}
            /> */}

            <Input
              title={tooltips.addStockEntryForm.volumePerUnit}
              id="volumePerUnit"
              autoComplete="off"
              className="num"
              label="Qtd por volume"
              value={item.volumePerUnit}
              type="text"
              onChange={handleItemChange}
              unitText={item.unitOfMeasurement}
            />
          </fieldset>
        )}

        <div className={style.containerSubmitButtons}>
          {showItemsDetailsForm && (
            <button type="button" onClick={addItem} className={style.btnAddItem}>
              Adicionar
            </button>
          )}

          <button disabled={isSubmitting} className={style.btnSubmit}>
            {isSubmitting ? 'Enviando...' : 'Enviar'}
          </button>

          {showItemsDetailsForm && (
            <button 
              type="button" 
              className={style.registerNotRegisteredBtnFooter}
              onClick={onOpenRegisterProduct}
              title="Cadastrar produto não encontrado em outra aba"
            >
              cadastrar produto<br />não encontrado
            </button>
          )}
        </div>
      </form>

      {/* {showPopupNote && (
        <ProductVolumeAdjustmentNote
          setNote={setNote}
          setShowPopupNote={setShowPopupNote}
          showPopupNote={showPopupNote}
        />
      )} */}
      {showItemsDetailsForm && item && renderTableItem()}
    </div>
  );
};
export default AddExpensesForm;
